import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from '../../contexts/TranslationContext';
import PageHero from '../../components/ui/page-hero';
import TimelineSection from '../../components/About/TimelineSection';
import ValuesSection from '../../components/About/ValuesSection';
import TeamSection from '../../components/About/TeamSection';

const About = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Helmet>
        <title>About Us | Envael - Leading Digital Transformation Company in Morocco</title>
        <meta name="description" content="Learn about Envael's mission to build Morocco's digital future. Discover our story, values, team, and commitment to delivering cutting-edge IT solutions, AI assistants, and business growth strategies." />
        <meta name="keywords" content="about envael, digital transformation morocco, IT company morocco, AI solutions, business growth, technology team, company values, morocco tech company" />
        <meta property="og:title" content="About Us | Envael - Leading Digital Transformation Company in Morocco" />
        <meta property="og:description" content="Learn about Envael's mission to build Morocco's digital future. Discover our story, values, team, and commitment to delivering cutting-edge IT solutions." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://envael.com/about" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | Envael - Leading Digital Transformation Company in Morocco" />
        <meta name="twitter:description" content="Learn about Envael's mission to build Morocco's digital future. Discover our story, values, team, and commitment to delivering cutting-edge IT solutions." />
        <link rel="canonical" href="https://envael.com/about" />
      </Helmet>

      <div className="min-h-screen bg-background">
      <PageHero 
        pageName={t('pages.about.title')} 
        subtitle={t('pages.about.subtitle')}
        size="large"
        fullHeight={false}
      />
      <TimelineSection />
      <ValuesSection />
      <TeamSection />
      </div>
    </>
  );
};

export default About;
